module.exports = __webpack_public_path__ + "static/media/kh.92662c35.svg";